module.exports = __webpack_public_path__ + "img/icon_ok_off.58e44b43.svg";